import { TUnitSettingStore } from '@/stores';

import { DefaultOptionType } from 'antd/es/select';

export interface IInner {}

export interface IOutter {}

export type IProps = IInner & IOutter;

export enum ESearchType {
	FULL_NAME = 'FULL_NAME',
	DISTRICT_ID = 'DISTRICT_ID',
	BIRTH_DATE = 'BIRTH_DATE',
	EMAIL = 'EMAIL',
	PHONE = 'PHONE',
	GENDER = 'GENDER',
	NATIONAL_CODE = 'NATIONAL_CODE',
	PASSPORT_NO = 'PASSPORT_NO',
	PASSPORT_ISSUE_DATE = 'PASSPORT_ISSUE_DATE',
	PASSPORT_EXPIRE_DATE = 'PASSPORT_EXPIRE_DATE',
	APPLICATION_TYPE = 'APPLICATION_TYPE',
	IS_RE_ENTRY = 'IS_RE_ENTRY',
	RE_ENTRY_COUNT = 'RE_ENTRY_COUNT',
	IS_PUBLIC = 'IS_PUBLIC',
	PUBLIC_FRANCHISE_ID = 'PUBLIC_FRANCHISE_ID',
	GRADE = 'GRADE',
	STATUS_ID = 'STATUS_ID',
	ISSUANCE_STATUS_ID = 'ISSUANCE_STATUS_ID',
	IS_VISA_ISSUANCE_CONFIRM_NO = 'IS_VISA_ISSUANCE_CONFIRM_NO',
	VISA_ISSUANCE_CONFIRM_NO = 'VISA_ISSUANCE_CONFIRM_NO',
	VISA_NO = 'VISA_NO',
	IS_FOREIGNER_NO = 'IS_FOREIGNER_NO',
	FOREIGNER_NO = 'FOREIGNER_NO',
	VISA_CODE = 'VISA_CODE',
	VISA_TIME = 'VISA_TIME',
	EXPIRATION_DATE = 'EXPIRATION_DATE',
	CHANGE_WORK_DATE = 'CHANGE_WORK_DATE',
	UNAUTHORIZED_DEPARTURE_DATE = 'UNAUTHORIZED_DEPARTURE_DATE',
	DEPARTURE_DATE = 'DEPARTURE_DATE',
	EXTENSION_PERIOD = 'EXTENSION_PERIOD',
	REGIST_DT = 'REGIST_DT',
	UPDATE_DT = 'UPDATE_DT',
	HOMETOWN_ADDR = 'HOMETOWN_ADDR',
	HOMETOWN_PHONE = 'HOMETOWN_PHONE',
	REENTRY_RECOMMENDATION_STATUS = 'REENTRY_RECOMMENDATION_STATUS',
	ENTRY_DATE = 'ENTRY_DATE',
	LODGING_ADDRESS = 'LODGING_ADDRESS',
	LODGING_ID = 'LODGING_ID',
	HEIGHT = 'HEIGHT',
	WEIGHT = 'WEIGHT',
	ID = 'ID',
	MEMO = 'MEMO',
	DEPARTURE_DATE_COUNT = 'DEPARTURE_DATE_COUNT',
	IS_WITHDRAWN = 'IS_WITHDRAWN',
	AGREEMENT_DT = 'AGREEMENT_DT',
	REGIST_UNIT_ID = 'REGIST_UNIT_ID',
	MID_TERM_DEPARTURE = 'MID_TERM_DEPARTURE',
}

export type TFilterProps = Partial<{
	districtList?: DefaultOptionType[];
	publicFranchiseList?: DefaultOptionType[];
	statusList?: DefaultOptionType[];
	issuanceStatusList?: DefaultOptionType[];
	optionalFieldApplicantList?: TUnitSettingStore['optionalFieldApplicantList'];
	isWorkerPublicAdminRole?: boolean;
	unitList?: DefaultOptionType[];
}>;
